export default __webpack_public_path__ + "static/media/3536 spice rack A side.03cabab9.png";